export default function(instance) {
  return {
    get() {
      return instance.get('/api/v2/wallets')
    },
    getBalance(currency) { // '' - for euro balance, '${song name}' for coin
      return instance.get(`/api/v2/wallets/${currency}`)
    },
  }
}